module.exports = __webpack_public_path__ + "static-portal/img/login-2.9f9e803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-2.png
// module id = rD1l
// module chunks = 4